import { createContext } from 'react';

const SmootherContext = createContext();

export default SmootherContext;
